module.exports = __webpack_public_path__ + "img/22.6fc8bbd8.png";